import { render, staticRenderFns } from "./RankingTabView.vue?vue&type=template&id=268a89e8&scoped=true"
import script from "./RankingTabView.vue?vue&type=script&lang=js"
export * from "./RankingTabView.vue?vue&type=script&lang=js"
import style0 from "./RankingTabView.vue?vue&type=style&index=0&id=268a89e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268a89e8",
  null
  
)

export default component.exports